import { useSelector } from "react-redux"

// ** Dropdowns Imports
import IntlDropdown from "./IntlDropdown"
import UserDropdown from "./UserDropdown"
import NavbarSearch from "./NavbarSearch"
import NotificationDropdown from "./NotificationDropdown"

// ** Third Party Components
import { Sun, Moon, Star } from "react-feather"
import { NavItem, NavLink, Button } from "reactstrap"

const NavbarUser = (props) => {
  const { userData } = useSelector((state) => state.auth)
  // ** Props
  const { skin, setSkin } = props

  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === "dark") {
      return <Sun className="ficon" onClick={() => setSkin("light")} />
    } else {
      return <Moon className="ficon" onClick={() => setSkin("dark")} />
    }
  }

  return (
    <ul className="nav navbar-nav align-items-center ml-auto">
      <NavItem className="d-none d-lg-block">
        <NavLink className="nav-link-style">
          {userData.role === "admin" && (
            <a
              href="https://www.earnify.io/book-demo"
              target="_blank"
              className="mr-4 btn"
              style={{ backgroundColor: "#FBBE24", color: "#fff" }}
            >
              <Star size={14} />
              <span className="align-middle ml-25">Upgrade</span>
            </a>
          )}
          <ThemeToggler />
        </NavLink>
      </NavItem>
      <UserDropdown />
    </ul>
  )
}
export default NavbarUser
